const house_sec1_part1Object = (payload) => {
  return {
    type: "housesec1part1object",
    payload,
  };
};

export default house_sec1_part1Object;
